<template>
  <main-layout>
    <b-card class="shadow-sm">
      <b-card-body>
        <h3 class="card-title font-weight-bold mb-4">
          Berufsbeiträge
        </h3>
        <h4 class="card-title font-weight-bold mb-4">
          Übersicht
        </h4>
        <u-error-handling
          v-if="errorObject"
          :error-object="errorObject"
        />
        <u-loader v-if="isLoading" />
        <div v-else>
          <span class="d-block"><b>Vertrag Nummer: </b>{{ vertragsId }}</span>
          <span class="d-block"><b>Name: </b>Test One</span>
          <span class="d-block"><b>Version: </b>{{ versionsId }}</span>
          <form
            class="mt-4"
            @submit.prevent="saveOverview"
          >
            <div class="form-group">
              <b-container class="pb-0 pt-0">
                <b-row>
                  <label class="pl-0 col-2 defaultLabel">Konto</label>
                  <div class="col-10 pl-0">
                    <v-flex sm12>
                      <v-text-field
                        id="professionContributionsAccountInput"
                        v-model="professionContribution.Account"
                        type="text"
                        label="Konto"
                        placeholder="Konto"
                      />
                    </v-flex>
                  </div>
                </b-row>
              </b-container>
            </div>
            <div class="mt-2">
              <div class="float-right">
                <button
                  id="'editprofessionContributionsDocuments"
                  v-b-tooltip.hover
                  type="button"
                  placement="bottom"
                  title="Unterlagen-Text bearbeiten"
                  class="btn btn-primary smallActionButton mr-1"
                  @click="editUnterlagen = !editUnterlagen"
                >
                  <i class="fas fa-edit" />
                </button>

                <button
                  id="'searchExistingProfessionContributionsDocuments"
                  v-b-tooltip.hover
                  v-b-modal.searchExistingDocumentsModal
                  type="button"
                  placement="bottom"
                  title="Nach existierendem Unterlagen-Text suchen"
                  class="btn btn-secondary smallActionButton"
                >
                  <i class="fas fa-search" />
                </button>
                <b-modal
                  id="searchExistingDocumentsModal"
                  ref="searchExistingDocumentsModal"
                  hide-footer
                  title="Unterlagen-Text suchen"
                  no-fade
                >
                  <b-button
                    variant="success"
                    @click="SetDocument"
                  >
                    Ok
                  </b-button>
                  <b-button
                    class="ml-2"
                    variant
                    @click="hideSearchExistingDocumentsModal"
                  >
                    Abbrechen
                  </b-button>
                </b-modal>
              </div>
              <h5 class="mb-4">
                Unterlagen
              </h5>
              <div v-if="!editUnterlagen">
                <span
                  style="white-space: pre-line"
                >{{
                  professionContribution.professionContributionContents[
                    professionContributionContentIds[0].value
                  ].Documents
                }}
                </span>
              </div>
              <div v-else>
                <u-multiline-multilanguage-text-input
                  id="professionContributionDocumentsInput"
                  v-model="
                    professionContribution.professionContributionContents
                  "
                  :is-multiline="true"
                  content-property-name="Documents"
                />
              </div>
            </div>
            <div class="mb-4 mt-4">
              <div class="float-right">
                <button
                  id="'editprofessionContributionsRemarks"
                  v-b-tooltip.hover
                  type="button"
                  placement="bottom"
                  title="Bemerkungen-Text bearbeiten"
                  class="btn btn-primary smallActionButton mr-1"
                  @click="editRemarks = !editRemarks"
                >
                  <i class="fas fa-edit" />
                </button>

                <button
                  id="'searchExistingRemarksModal"
                  v-b-tooltip.hover
                  v-b-modal.searchExistingRemarksModal
                  type="button"
                  placement="bottom"
                  title="Nach existierendem Bemerkungen-Text suchen"
                  class="btn btn-secondary smallActionButton"
                >
                  <i class="fas fa-search" />
                </button>
                <b-modal
                  id="searchExistingRemarksModal"
                  ref="searchExistingRemarksModal"
                  hide-footer
                  title="Bemerkungs-Text suchen"
                  no-fade
                >
                  <b-button
                    variant="success"
                    @click="SetRemark"
                  >
                    Ok
                  </b-button>
                  <b-button
                    class="ml-2"
                    variant
                    @click="hideSearchExistingRemarksModal"
                  >
                    Abbrechen
                  </b-button>
                </b-modal>
              </div>
              <h5 class="mb-2">
                Bemerkungen
              </h5>

              <div v-if="!editRemarks">
                <span style="white-space: pre-line">
                  {{
                    professionContribution.professionContributionContents[
                      professionContributionContentIds[0].value
                    ].Remarks
                  }}
                </span>
              </div>
              <div v-else>
                <u-multiline-multilanguage-text-input
                  id="professionContributionRemarksInput"
                  v-model="
                    professionContribution.professionContributionContents
                  "
                  :is-multiline="true"
                  content-property-name="Remarks"
                />
              </div>
            </div>
            <b-button
              id="saveProfessionContributionOverview"
              type="submit"
              variant="success"
              class="mr-2"
            >
              Speichern
            </b-button>
            <b-button
              id="cancelProfessionContributionOverview"
              variant="danger"
              @click="cancelOverviewEdit"
            >
              Abbrechen
            </b-button>
          </form>
        </div>
      </b-card-body>
    </b-card>
    <b-card class="shadow-sm mt-4">
      <b-card-body>
        <h4 class="card-title font-weight-bold mb-4">
          Jahresübersicht
        </h4>
        <form
          class="mt-4"
          @submit.prevent="saveYearlyOverview"
        >
          <v-flex sm4>
            <v-select
              v-model="selectedOverviewYear"
              :items="AllYears"
              label="Jahr"
            />
          </v-flex>
          <v-radio-group
            v-model="selectedOverviewYearObject.Deduction"
            :mandatory="true"
          >
            <v-radio
              label="kein Abzug, keine Rückerstattung"
              :value="false"
            />
            <v-radio
              label="Abzug und Rückerstattung"
              :value="true"
            />
          </v-radio-group>
          <div
            v-if="selectedOverviewYearObject.Deduction"
            class="ml-4"
          >
            <b-row>
              <b-col cols="4">
                <v-text-field
                  type="number"
                  class="mr-4 normalFontSize"
                  label="Abzug"
                />
              </b-col>
              <b-col cols="8">
                <v-text-field
                  type="text"
                  class="mr-4 normalFontSize"
                  label="Abzug Einheit"
                />
              </b-col>
            </b-row><b-row>
              <b-col cols="4">
                <v-text-field
                  type="number"
                  class="mr-4 normalFontSize"
                  label="Rückerstattungsbasis Wert"
                />
              </b-col>
              <b-col cols="8">
                <v-text-field
                  type="text"
                  class="mr-4 normalFontSize"
                  label="Rückerstattungsbasis Einheit"
                />
              </b-col>
            </b-row><b-row>
              <b-col cols="4">
                <v-text-field
                  type="number"
                  class="mr-4 normalFontSize"
                  label="Maximale Rückerstattungsbasis Wert"
                />
              </b-col>
              <b-col cols="8">
                <v-text-field
                  type="text"
                  class="mr-4 normalFontSize"
                  label="Maximale Rückerstattungsbasis Einheit"
                />
              </b-col>
            </b-row>
          </div>
          <b-button
            id="saveProfessionContributionYears"
            type="submit"
            variant="success"
            class="mr-2"
          >
            Speichern
          </b-button>
          <b-button
            id="cancelProfessionContributionYears"
            variant="danger"
            @click="cancelYearsEdit"
          >
            Abbrechen
          </b-button>
        </form>
      </b-card-body>
    </b-card>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import { GetProfessionContribution } from "@/services/contract.edition.professionContributions.service";

export default {
  components: {
    MainLayout,
  },
  data() {
    return {
      vertragsId: "",
      versionsId: "",
      editionsId: "",
      isLoading: false,
      errorObject: null,
      professionContribution: null,
      editUnterlagen: false,
      editRemarks: false,
      searchedRemark: "",
      searchedDocument: "",
      AllYears: [],
      selectedOverviewYear: "",
      selectedOverviewYearObject: null,
      professionContributionContentIds: [
        { language: "de-CH", value: -1 },
        { language: "fr-CH", value: -1 },
        { language: "it-CH", value: -1 },
      ],
      translatableLanguages: {
        "de-CH": { language: "de-CH", label: "Deutsch", selected: false },
        "fr-CH": { language: "fr-CH", label: "Französisch", selected: false },
        "it-CH": { language: "it-CH", label: "Italienisch", selected: false },
      },
    };
  },
  watch: {
    selectedOverviewYear(newValue) {
      if (this.professionContribution) {
        var selectedObject = this.professionContribution.YearylOverviews.filter(
          (overView) => {
            return overView.Year == newValue;
          },
        );

        if (selectedObject && selectedObject.length == 1) {
          this.selectedOverviewYearObject = selectedObject[0];
        }
      }
    },
  },
  created() {
    this.vertragsId = this.$route.params.vertragsId;
    this.versionsId = this.$route.params.versionsId;

    this.LoadProfessionContribution();
  },
  methods: {
    cancelOverviewEdit() {
      this.editUnterlagen = false;
      this.editRemarks = false;
      this.LoadProfessionContribution();
    },
    cancelYearsEdit() {},
    SetRemark() {
      this.hideSearchExistingRemarksModal();
    },
    SetDocument() {
      this.hideSearchExistingDocumentsModal();
    },
    hideSearchExistingDocumentsModal() {
      this.$refs["searchExistingDocumentsModal"].hide();
    },
    hideSearchExistingRemarksModal() {
      this.$refs["searchExistingRemarksModal"].hide();
    },
    LoadProfessionContribution() {
      this.isLoading = true;

      GetProfessionContribution(
        this.vertragsId,
        this.versionsId,
        (response) => {
          this.isLoading = false;
          this.professionContribution = response;

          this.professionContribution.YearylOverviews.map((yearlyOverview) => {
            this.AllYears.push(yearlyOverview.Year);
          });

          if (this.AllYears.length > 0) {
            this.selectedOverviewYear = this.AllYears[0];
          }

          this.professionContributionContentIds.map(
            (professionContributionContentLangaugeSetting) => {
              var languageSetting =
                this.professionContribution.professionContributionContents.filter(
                  (contractContent) => {
                    return (
                      contractContent.language ==
                      professionContributionContentLangaugeSetting.language
                    );
                  },
                );

              if (languageSetting.length == 1) {
                professionContributionContentLangaugeSetting.value =
                  this.professionContribution.professionContributionContents.indexOf(
                    languageSetting[0],
                  );
              }
            },
          );
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped>
.contractOverViewTabControl .shadow-sm {
  border-top: none;
  border-radius: 0px;
}
.contractOverViewTabControl {
  width: 100%;
}
.tab-pane {
  outline: none !important;
}

.smallActionButton {
  width: 30px;
  height: 30px;
  font-size: 17px;
  padding: 0px;
}
</style>
